module.exports = __webpack_public_path__ + "media/images/icons/twotone/layout-711a526612e0dcc9b6d97be149536c32.svg";